// Libs
import { ModelBase } from "@shoothill/core";
import * as MobX from "mobx";
// App
import { DashboardModelDTO } from "../../DTO/DashboardModelDTO";
import { DashboardApplicationModel } from "./DashboardApplicationModel";

export class DashboardModel extends ModelBase<DashboardModel, DashboardModelDTO> {
    @MobX.observable public applicationModels: DashboardApplicationModel[] = [];
    @MobX.observable public canStartNewApplicationForm: boolean = true;

    @MobX.action
    public fromDto = (model: DashboardModelDTO): void => {
        if (model !== null && model !== undefined) {
            model.applicationForms.forEach((application) => {
                let localApplicationModel: DashboardApplicationModel = new DashboardApplicationModel();
                localApplicationModel.fromDto(application);
                this.applicationModels.push(localApplicationModel);
            });
            this.canStartNewApplicationForm = model.canStartNewApplicationForm;
        }
    };

    public toDto = (): DashboardModelDTO => {
        let model: DashboardModelDTO = {
            applicationForms: this.applicationModels,
            canStartNewApplicationForm: this.canStartNewApplicationForm,
        };
        return model;
    };
}
